import { createInjectionKey as o } from "./ghl-ui.es848.js";
const n = o("n-modal-provider"), t = o("n-modal-api"), i = o("n-modal-reactive-list");
export {
  t as modalApiInjectionKey,
  n as modalProviderInjectionKey,
  i as modalReactiveListInjectionKey
};
